import { useContext } from 'react'
import styled from '@emotion/styled'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useIntegrationAssignment } from '@global/hooks'
import { templateCopyContext } from '../../../../context'

const MarginFormControl = styled(FormControlLabel)`
  align-content: left;
`

interface CheckboxFieldProps {
  label: string
  checked: boolean
  integrationAssignment: any
  metadataKey: string
}

export const CheckboxField = ({
  label,
  checked,
  integrationAssignment,
  metadataKey,
}: CheckboxFieldProps) => {
  const { onChange } = useContext<any>(templateCopyContext)
  const { onIntegrationMetadataChange } = useIntegrationAssignment({
    integrationAssignment,
    onChange,
  })

  return (
    <MarginFormControl
      control={
        <Checkbox
          checked={checked}
          onChange={e => {
            onIntegrationMetadataChange(e.target.checked, metadataKey)
          }}
        />
      }
      label={label}
    />
  )
}
